/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { TableFooterContent } from './components';
import * as S from './styles';

const TicketListFooter = ({ retrieved = 0, refetch = () => {}, isLoadingOrRefetching = false }) => {
  return (
    <S.StyledGridFooterContainer>
      <TableFooterContent retrieved={retrieved} refetch={refetch} isLoadingOrRefetching={isLoadingOrRefetching} />
    </S.StyledGridFooterContainer>
  );
};

export { TicketListFooter };
